var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"risk-level-info"},[_c('b-badge',{staticClass:"risk-level-pill",attrs:{"pill":"","variant":_vm.pillColor}},[_vm._v(_vm._s(_vm.riskLevel))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }